import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Logo from '@comp/Logo/Logo';
import { Spacings, mediaQuery } from '@styles/index';
import HeaderTop from '../Components/HeaderContainer';
import HeaderContent from '../Components/HeaderParent';

const HeaderContainer = styled(HeaderTop)`
  position: static;
`;

const HeaderParent = styled(HeaderContent)`
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
  }
`;

const Header = () => {
  const router = useRouter();
  const { route } = router;
  return (
    <HeaderContainer>
      <HeaderParent>
        <Logo isClassroom={route.includes('classroom')} />
      </HeaderParent>
    </HeaderContainer>
  );
};

export default Header;
